<div class="consultation-grid mt-5">

  <!-- ZONE DE TEXTE AVEC OUTILS -->
  <div class="card-text">

    <div class="header-flex">
      <label for="Planning de Rééducation">{{doctor.actionplan == true ? 'Plan de Action' :'Planning de Rééducation'}}</label>

      <div class="tools-wrapper">
        <!-- Liste de questions partagées -->
        <div class="question-plugin">
          <app-liste-question-sahred
            [filter]="this.doctor.actionplan===true ? 'Plan Action':'Planning Rééducation'"
            [(value)]="consultation.consultationReeducation"
            [(listeQuestionsConsultations)]="tableauTextFillings"
            [options]="{right:'-10px', top:'30px'}"
          ></app-liste-question-sahred>
        </div>

        <!-- Micro dictée -->
        <button class="openDialoge mic-btn" *ngIf="canDictate"
                [class.mic-active]="isMicActive('consultationReeducation')"
                (click)="toggleMic('consultationReeducation')">
          <i class="feather-mic"></i>
        </button>
      </div>
    </div>

    <angular-editor [config]="editorConfig" [(ngModel)]="consultation.consultationReeducation" class="editor"></angular-editor>

  </div>

  <!-- INTERVENANT (Toujours compact à côté) -->
  <div class="card-options" *ngIf="doctor.actionplan !==true">
    <label>Praticien</label>
    <select [(ngModel)]="selectedUser" class="modern-select" (change)="onUserChange()">
      <option *ngFor="let user of usersList" [ngValue]="user">
        {{ user.fullName }}
      </option>
    </select>
  </div>

</div>

<app-modal
  [title]="questions.id==''?'Ajouter nouvelle Question':'Mise a jour  Question'"
  #dialog
>
  <app-text-fillings-form
    *ngIf="questions.id!==''"
    [submitName]="'Mise a jour  Question'"
    [textFilligns]="questions"
    (submit)="callUpdateQuestion($event)"
  ></app-text-fillings-form>
  <app-text-fillings-form
    *ngIf="questions.id==''"
    [submitName]="'Ajouter Question'"
    [textFilligns]="questions"
    (submit)="callAddQuestion($event)"
  ></app-text-fillings-form>
</app-modal>